import openApiHttp from "@/utils/request2"
export let newlist = (params) => {
    return openApiHttp({
        url: "/news/listByPage",
        params,
    }, true)
}
export let authorregister = (data) => {
    return openApiHttp({
        url: "/author/register",
        method: "post",
        data,
    }, true)
}
export let replylist = (params) => {
    return openApiHttp({
        url: "/author/listBookCommentByPage",
        params,
    }, true)
}
//作者信息更新
export let updateAuthor = (data) => {
    return openApiHttp({
        url: "/author/updateAuthor",
        headers: { 'Content-Type': 'application/json' },
        method: "post",
        data,
    }, true)
}
//获取作者信息
export let getAuthorInfo = (id) => {
    return openApiHttp({
        url: `/author/queryAuthor/${id}`,
    }, true)
}
//发布小说
export let createbook = (data) => {
    return openApiHttp({
        url: "/author/addBook",
        headers: { 'Content-Type': 'application/json' },
        method: "post",
        data,
    }, true)
}
//更新小说
export let Updatebook = (data) => {
    return openApiHttp({
        url: "/author/updateBook",
        method: "post",
        headers: { 'Content-Type': 'application/json' },
        data,
    }, true)
}
//获取小说
export let getauthorbook = (bookId) => {
    return openApiHttp({
        url: "/author/queryBook",
        method: "get",
        params: {
            bookId,
        }
    }, true)
}
//作者书架
export let getbooklist = (params) => {
    return openApiHttp({
        url: "/author/listBookByPage",
        params,
    }, true)
}
//点击量
export let clickNum = (params) => {
    return openApiHttp({
        url: "/author/queryAuthorBookVisitCount",
        params,
    }, true)
}
//消费统计
export let payNum = (params) => {
    return openApiHttp({
        url: "/author/queryAuthorBookPurchase",
        params,
    }, true)
}
// 收藏
export let favoriteNum = (params) => {
    return openApiHttp({
        url: "/author/queryAuthorBookCollection",
        params,
    }, true)
}
//充值记录
export let rechargeRecord = (params) => {
    return openApiHttp({
        url: "/user/BookOrderPay",
        params,
    }, true)
}
//收入记录
export let revenueRecord = (params) => {
    return openApiHttp({
        url: "/author/authorMonthIncome",
        params,
    }, true)
}
//提现记录
export let withdrawalRecord = (params) => {
    return openApiHttp({
        url: "/author/AuthorWithdrawalByPage",
        params,
    }, true)
}
// 收入总数
export let totalIncome = () => {
    return openApiHttp({
        url: "/author/authorMonthIncomeCount",
    }, true)
}
// 申请提现
export let applyWithdrawal = (data) => {
    return openApiHttp({
        url: "/author/saveAuthorWithdrawal",
        headers: { 'Content-Type': 'application/json' },
        method: "post",
        data,
    }, true)
}
//消息列表
export let messagelist = (params) => {
    return openApiHttp({
        url: "/author/listkafkaOfficialMessage",
        params,
    }, true)
}
//新闻心情
export let newsdetail = (id) => {
    return openApiHttp({
        url: `/news/news/${id}`,
    }, true)
}
//消息已读
export let messageread = (data) => {
    return openApiHttp({
        url: "/book/clickComment",
        method: "post",
        data,
    }, true)
}